import React, { useEffect } from 'react'
import { Box, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material'

interface MonthYearFilterProps {
  value: string // "YYYY-MM" or ""
  onChange: (value: string) => void
  availableYears?: number[]
  selectedYear: string
  setSelectedYear: React.Dispatch<React.SetStateAction<string>>
  selectedMonth: string
  setSelectedMonth: React.Dispatch<React.SetStateAction<string>>
}

const MonthYearFilter: React.FC<MonthYearFilterProps> = ({
  value,
  onChange,
  availableYears,
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
}) => {
  const years = availableYears || [2023, 2024, 2025]

  const months = [
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ]

  useEffect(() => {
    const [year, month] = value.split('-')
    if (year) setSelectedYear(year)
    if (month) setSelectedMonth(month)
  }, [value])

  const handleYearChange = (event: SelectChangeEvent<string>) => {
    const newYear = event.target.value
    setSelectedYear(newYear)
    if (selectedMonth) {
      onChange(`${newYear}-${selectedMonth}`)
    }
  }

  const handleMonthChange = (event: SelectChangeEvent<string>) => {
    const newMonth = event.target.value
    setSelectedMonth(newMonth)
    if (selectedYear) {
      onChange(`${selectedYear}-${newMonth}`)
    }
  }

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <FormControl variant="outlined" size="small" sx={{ width: 100 }}>
        <InputLabel id="year-filter-label">Year</InputLabel>
        <Select labelId="year-filter-label" value={selectedYear} onChange={handleYearChange} label="Year">
          {years.map(year => (
            <MenuItem key={year} value={year.toString()}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small" sx={{ width: 150 }}>
        <InputLabel id="month-filter-label">Month</InputLabel>
        <Select labelId="month-filter-label" value={selectedMonth} onChange={handleMonthChange} label="Month">
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {months.map(month => (
            <MenuItem key={month.value} value={month.value}>
              {month.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default MonthYearFilter
